export const mutations = {
  addFilm(state, film) {
    state.film = film;
  },
  setFilm(state, film) {
    state.film = film;
  },
  addFilms(state, film) {
    state.films = [...film];
  },
  addfilmsPage(state, film) {
    state.films = film;
  },
  replaceFilm(state, film) {
    state.films = state.films.map((el) =>
      el.id === film.id ? film : el
    );
  },
  removeFilm(state, film) {
    state.films = state.films.filter((el) => el.id !== film.id);
  },
  setFilm(state, film) {
    state.film = film;
  },
};
